import React from 'react';
import { Language } from '../types';
import { LANGUAGES } from '../utils/translations';
import { X, Globe } from 'lucide-react';
interface LanguageSelectorProps {
  onSelect: (language: Language) => void;
  onCancel: () => void;
}
export function LanguageSelector({
  onSelect,
  onCancel
}: LanguageSelectorProps) {
  return <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" data-id="element-260">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full" data-id="element-261">
        <div className="flex items-center justify-between p-6 border-b" data-id="element-262">
          <div className="flex items-center gap-3" data-id="element-263">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-264">
              <Globe className="w-5 h-5 text-blue-600" data-id="element-265" />
            </div>
            <div data-id="element-266">
              <h2 className="text-xl font-semibold" data-id="element-267">Etikett-Sprache wählen</h2>
              <p className="text-sm text-gray-600" data-id="element-268">
                In welcher Sprache soll das Etikett erstellt werden?
              </p>
            </div>
          </div>
          <button onClick={onCancel} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-269">
            <X className="w-5 h-5" data-id="element-270" />
          </button>
        </div>

        <div className="p-6 space-y-3" data-id="element-271">
          {(Object.keys(LANGUAGES) as Language[]).map(lang => <button key={lang} onClick={() => onSelect(lang)} className="w-full flex items-center gap-4 p-4 border-2 border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all group" data-id="element-272">
              <span className="text-3xl" data-id="element-273">{LANGUAGES[lang].flag}</span>
              <span className="text-lg font-medium text-gray-900 group-hover:text-blue-600" data-id="element-274">
                {LANGUAGES[lang].name}
              </span>
            </button>)}
        </div>
      </div>
    </div>;
}